import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faBars, faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Header.css';
import logo from '../../assets/images/logo/logo.png';
// Auth entfernt

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown: string) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      // Dropdown nur schließen, wenn außerhalb des Headers geklickt wird
      if (target && !target.closest('.header')) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Prevent closing dropdown when clicking inside
  const handleDropdownClick = (e: React.MouseEvent, dropdown: string) => {
    e.stopPropagation();
    toggleDropdown(dropdown);
  };

  return (
    <>
    <header className="header">

      
      <div className="main-header">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="IB Neubaur GmbH" />
            </Link>
          </div>
          
          <div className="contact-section">
            <div className="contact-item">
              <a href="tel:+4990909590010" className="contact-link">
                <FontAwesomeIcon icon={faPhone} />
                <span>+49 (0) 90 90 - 95 900-10</span>
              </a>
            </div>
            <div className="contact-item">
              <a href="mailto:info@neubaur-gmbh.de" className="contact-link">
                <FontAwesomeIcon icon={faEnvelope} />
                <span>info@neubaur-gmbh.de</span>
              </a>
            </div>
            {/* Login entfernt */}
          </div>
          
          <div className="nav-wrapper">
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
          
          <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
            <ul>
              <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li className={`dropdown dropdown-fachgebiete ${activeDropdown === 'fachgebiete' ? 'active' : ''}`}>
                <button
                  type="button"
                  className="dropdown-toggle"
                  aria-haspopup="true"
                  aria-expanded={activeDropdown === 'fachgebiete'}
                  onClick={(e) => handleDropdownClick(e, 'fachgebiete')}
                >
                  Fachgebiete <FontAwesomeIcon icon={faChevronDown} size="xs" />
                </button>
                <ul className="dropdown-menu fachgebiete-dropdown">
                  <li><Link to="/elektrotechnik" onClick={() => setIsMenuOpen(false)}>Elektrotechnik</Link></li>
                  <li><Link to="/energietechnik" onClick={() => setIsMenuOpen(false)}>Energietechnik</Link></li>
                  <li><Link to="/foerdertechnik" onClick={() => setIsMenuOpen(false)}>Fördertechnik</Link></li>
                  <li><Link to="/iuk" onClick={() => setIsMenuOpen(false)}>IuK</Link></li>
                  <li><Link to="/sicherheitstechnik" onClick={() => setIsMenuOpen(false)}>Sicherheitstechnik</Link></li>
                  <li><Link to="/hls" onClick={() => setIsMenuOpen(false)}>HLS</Link></li>
                </ul>
              </li>
              <li><Link to="/referenzen" onClick={() => setIsMenuOpen(false)}>Referenzen</Link></li>
              <li className={`dropdown dropdown-ueberuns ${activeDropdown === 'ueberuns' ? 'active' : ''}`}>
                <button
                  type="button"
                  className="dropdown-toggle"
                  aria-haspopup="true"
                  aria-expanded={activeDropdown === 'ueberuns'}
                  onClick={(e) => handleDropdownClick(e, 'ueberuns')}
                >
                  Über uns <FontAwesomeIcon icon={faChevronDown} size="xs" />
                </button>
                <ul className="dropdown-menu">
                  <li><Link to="/ueber-uns" onClick={() => setIsMenuOpen(false)}>Über uns</Link></li>
                  <li><Link to="/software" onClick={() => setIsMenuOpen(false)}>Software & Tools</Link></li>
                  <li><Link to="/bim" onClick={() => setIsMenuOpen(false)}>BIM</Link></li>
                  <li><Link to="/denkmalschutz" onClick={() => setIsMenuOpen(false)}>Denkmalschutz</Link></li>
                  <li><Link to="/stellenangebote" onClick={() => setIsMenuOpen(false)}>Stellenangebote</Link></li>
                </ul>
              </li>
              <li><Link to="/kontakt" onClick={() => setIsMenuOpen(false)}>Kontakt</Link></li>
            </ul>
          </nav>
          </div>
        </div>
      </div>
    </header>
    {/* AuthModal entfernt */}
    </>
  );
};

export default Header;